/**
 * Wat er geladen moet zijn vóór de hydratie. De modules van de routes op de
 * pagina draaien in de browser vóór entry.client (React Router importeert
 * ze eerst); een route meldt hier wat er vóór de hydratie binnen moet zijn,
 * en entry.client wacht erop.
 *
 * Waarom: een luie lade die al open staat (een diepe link, een
 * herlaadbeurt op /vandaag?tray=status) staat in de HTML van de server.
 * Is zijn code bij de hydratie nog niet binnen, dan wacht zijn
 * Suspense-grens nog als Vandaag opnieuw rendert; React gooit de HTML van
 * de server dan weg en bouwt de lade opnieuw op, met een flits en een
 * ingang die er niet hoort (data-rust, lagen.ts).
 *
 * Mislukt een lading, dan hydrateert de pagina toch: de lade laadt dan
 * zoals na een tik.
 */
const wachten: Array<Promise<unknown>> = []

export function laadVoorHydratie(laad: () => Promise<unknown>) {
	wachten.push(laad().catch(() => {}))
}

export function voorHydratie(): Promise<unknown> {
	return Promise.all(wachten)
}
